import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRoute, stateEnum } from "../constants/enum"
import { toast } from "react-toastify"
import customAPI from "../api/customAPI.js"
const { receiveEntry } = stateEnum
const initialState = {
    detailParams: {},
    isNewEntry: false,
    recVouDetail: [],
    isRediOutstanding: false,
    rediBillNo:[]
}

export const setEntryDetail = createAsyncThunk("getEntryDetail",
    async ({ token, transactionid, compcode, pacid, voutype, db_user }) => {
        try {
            const { data } = await customAPI.post(
                apiRoute.transaction.receiveEntry.fetchEntryDetail, {
                transaction_id: transactionid,
                comp_code: compcode,
                pac_id: pacid,
                vou_type: voutype,
                db_user: db_user
            },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )
            return data.data
        }
        catch (error) {
            toast.error("Data not found", {
                position: "top-center"
            })
            console.log(error)
        }

    }

)

const receiveEntrySlice = createSlice({
    name: receiveEntry,
    initialState,
    reducers: {
        resetDetailParams: (state) => {
            state.detailParams = {}
            state.isNewEntry = true
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },
        setVouReportDetail: (state, action) => {
            state.recVouDetail = [action.payload]
        },
        resetRecVouDetail: (state, action) => {
            state.recVouDetail = []
        },
         setIsRediOutstanding: (state, action) => {
            state.isRediOutstanding = action.payload.redirect
            state.rediBillNo=action.payload.billno
        }

    },
    // extraReducers:(builder)=>{
    //     builder
    //     .addCase(setEntryDetail.fulfilled,(state,action)=>{

    //         state.detail=action.payload;

    //     })
    //     .addCase(setEntryDetail.rejected,(state,action)=>{
    //         state.detail=[]
    //     })

    // }
})

export const { resetDetailParams, setNewEntryMode, setVouReportDetail,setIsRediOutstanding, resetRecVouDetail, setDetailParams } = receiveEntrySlice.actions

export default receiveEntrySlice.reducer

